import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getAnalyticsSessionId, trackEvent } from '../lib/analytics';

export default function AnalyticsTracker() {
  const location = useLocation();
  const lastPathRef = useRef(null);
  const lastAtRef = useRef(Date.now());

  useEffect(() => {
    getAnalyticsSessionId();
  }, []);

  useEffect(() => {
    const path = `${location.pathname}${location.search || ''}`;
    const now = Date.now();

    if (lastPathRef.current) {
      const seconds = Math.max(1, Math.round((now - lastAtRef.current) / 1000));
      trackEvent('time_on_page', lastPathRef.current, seconds);
    }

    lastPathRef.current = path;
    lastAtRef.current = now;
    trackEvent('page_view', path);
  }, [location]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      if (!lastPathRef.current) return;
      const seconds = Math.max(1, Math.round((Date.now() - lastAtRef.current) / 1000));
      const payload = JSON.stringify({
        session_id: getAnalyticsSessionId(),
        event_type: 'time_on_page',
        page: lastPathRef.current,
        value: String(seconds),
        metadata: {},
      });
      navigator.sendBeacon(`${process.env.REACT_APP_BACKEND_URL}/api/track/event`, payload);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);

  return null;
}
